import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-vehicle-info" }
const _hoisted_2 = { class: "row container-vehicle-info__main-header" }
const _hoisted_3 = { class: "col-sm-12 col-md-12 col-lg-11 d-flex d-flex align-items-baseline justify-content-between" }
const _hoisted_4 = { class: "mb-0" }
const _hoisted_5 = {
  class: "font-big link-choose-vehicle",
  "data-bs-toggle": "modal",
  "data-bs-target": "#selectVehicleModal"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-sm-6 col-md-6 col-lg-4" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "col-sm-6 col-md-6 col-lg-8 container-vehicle-info__main-info-1" }
const _hoisted_10 = { class: "col-8 container-vehicle-info__name font-big" }
const _hoisted_11 = { class: "col-8 container-vehicle-info__price font-big" }
const _hoisted_12 = { class: "col-8 container-vehicle-info__free-items" }
const _hoisted_13 = { class: "modal-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VehicleCardFreeItemWrapperComponent = _resolveComponent("VehicleCardFreeItemWrapperComponent")!
  const _component_VehicleSelectWrapperComponent = _resolveComponent("VehicleSelectWrapperComponent")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.$t('order_vehicle')), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('select_other')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("img", {
            class: "container-vehicle-info__main-photo",
            src: _ctx.vehicle.vehicle_main_image ? _ctx.vehicle.vehicle_main_image.path : '',
            alt: "selected-vehicle-photo"
          }, null, 8, _hoisted_8)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.vehicle.make + ' ' + _ctx.vehicle.model), 1),
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.vehicle.price) + " " + _toDisplayString(_ctx.$t('eur_h')), 1),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_VehicleCardFreeItemWrapperComponent, { class: "justify-content-start gap-3" })
          ])
        ])
      ])
    ]),
    _createVNode(_component_ModalComponent, {
      "show-title": false,
      "id-data": 'selectVehicleModal'
    }, {
      "body-content": _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_VehicleSelectWrapperComponent, { "is-main-modal": false })
        ])
      ]),
      _: 1
    })
  ], 64))
}